import React, { useState } from 'react'
import DefineAdSlot from '../Ads/DefineAdSlot'
import { adTierConfigs } from '../Ads/adTierConfigs'
import { useAdTargeting } from '../../hooks/useAdTargeting'
import '../../styles/AdSection/AdSection.scss'

interface AdContainerProps {
    tierName?: keyof typeof adTierConfigs
    dynamicTargeting?: Record<string, string | string[]>
}

const AdContainer = ({
  tierName = 'under25',
  dynamicTargeting = {}
}: AdContainerProps) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const currentTier = adTierConfigs[tierName]

  useAdTargeting(currentTier, dynamicTargeting)

  if (!currentTier) {
    console.warn(`AdContainer: Ad tier "${tierName}" not found in adTierConfigs.`)
    return null
  }

  const { baseAdUnitPath, slots } = currentTier

  return (
        <div className="advert__container">
            <h2 className="advert__title">Check out these products that can impact your finances</h2>
            <p className="advert__text">Start working towards financial wealth and security by exploring these low-cost
                investing opportunities.</p>
            <div className="advert__slots_container">
                {slots.map((slotConfig, index) => {
                  const slotId = `${tierName}-ad-${slotConfig.slotIdSuffix || index}`
                  return (
                        <div key={slotId} className="advert__slot">
                            <DefineAdSlot
                                adUnitPath={baseAdUnitPath}
                                size={slotConfig.size}
                                slotId={slotId}
                                targeting={{
                                  position: slotConfig.position
                                }}
                            />
                        </div>
                  )
                })}
            </div>
            <div className="advert__disclosure_wrapper">
                <span className="advert__disclosure_date">
                  APYs displayed are as of <span>{new Date().toLocaleDateString()}</span>.
                </span>
                <div className="advert__disclosure_tooltip_container">
                    <span
                        className="advert__disclosure_link"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        onFocus={() => setShowTooltip(true)}
                        onBlur={() => setShowTooltip(false)}
                        tabIndex={0}
                        role="button"
                        aria-expanded={showTooltip}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowTooltip(prev => !prev) }}
                    >
                        Ad Disclosure
                    </span>
                    {showTooltip && (
                        <div className="advert__tooltip" role="tooltip">
                            The offers that appear on this site are from companies from which SmartAsset.com receives compensation.
                            This compensation may impact how and where products appear on this site (including, for example,
                            the order in which they appear). Bank, thrift and credit union deposits are insured by the FDIC or NCUA.
                            Rates are subject to change without notice and may not be the same at all branches.
                            Please contact the financial institution for the terms and conditions that may apply to you.
                            SmartAsset.com does not include all providers or product offers available in the marketplace.
                        </div>
                    )}
                </div>
            </div>

            <div className="advert__disclosure-static-text">
                SmartAsset receives compensation from these third-parties for marketing their products or services or
                based on Users purchasing their products or services.
                SmartAsset&apos;s receipt of such compensation from these third-parties creates a conflict of interest for
                SmartAsset to provide information about third-parties that provide such compensation,
                rather than third-parties that do not provide such compensation.
            </div>
        </div>

  )
}

export default AdContainer
